import React from 'react';
import PropTypes from 'prop-types';
import { Table, Button, Popover, Tag, Divider, Checkbox } from 'antd';
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';
import './styles.css';
import cloneDeep from 'lodash.clonedeep';

const { Column } = Table;

const RestaurantsPriorityTable = ({ data, priorityArrayToSave, onMove, onChangeEnabledState }) => {
    const dataSource = cloneDeep(data)
    const priorityArrayToSaveSource = cloneDeep(priorityArrayToSave)
    return (
        <Table className="restaurantsTableCont" dataSource={dataSource} rowKey="id" size="middle" pagination={false}>
            <Column title="Habilitado" dataIndex="enabled" key="enabled" align="center" width="5%"
                render={(text, record) => (
                    <span>
                        {
                            <Checkbox checked={record.enabled} onChange={(e) => onChangeEnabledState(e.target.checked, record.id)}/>
                        }
                    </span>
                )}
            />
            <Column title="Acción" dataIndex="state" key="action" align="center" width="25%"
                render={(text, record) => (
                    <span>
                        {
                            priorityArrayToSaveSource && priorityArrayToSaveSource.length > 1 ?
                                priorityArrayToSaveSource.indexOf(record.id) === 0 ?
                                    <Button type="primary" onClick={() => onMove("DOWN", record.id)} disabled={!record.enabled}>
                                        <CaretDownOutlined />
                                    </Button>
                                    :
                                    priorityArrayToSaveSource.indexOf(record.id) === (priorityArrayToSaveSource.length - 1) ?
                                        <Button type="primary" onClick={() => onMove("UP", record.id)} disabled={!record.enabled}>
                                            <CaretUpOutlined />
                                        </Button>
                                        :
                                        <span>
                                            <Button type="primary" onClick={() => onMove("UP", record.id)} disabled={!record.enabled}>
                                                <CaretUpOutlined />
                                            </Button>
                                            <Divider type="vertical"/>
                                            <Button type="primary" onClick={() => onMove("DOWN", record.id)} disabled={!record.enabled}>
                                                <CaretDownOutlined />
                                            </Button>
                                        </span>
                                :
                                <span>
                                    <Button type="primary" disabled={true}>
                                        <CaretUpOutlined />
                                    </Button>
                                    <Divider type="vertical"/>
                                    <Button type="primary" disabled={true}>
                                        <CaretDownOutlined />
                                    </Button>
                                </span>
                        }
                    </span>
                )}
            />
            <Column className="nameCont" title="Nombre" dataIndex="name" key="name" align="center" width="50%"
            render={(text, record) => {
                if(record.inCity) {
                    return (
                    <span>
                        <Popover content={
                            <div>
                                {record.id}
                            </div>
                        }>
                            {
                                record.enabled ?
                                    <div>{record.name}</div>
                                    :
                                    <strike style={{ color: '#aaaaaa' }}>{record.name}</strike>
                            }
                        </Popover>
                    </span>);
                } else {
                    return (
                        <span>
                            <Popover content={
                                <div>
                                    {record.id}
                                </div>
                            }>
                                {
                                    record.enabled ?
                                        <div>{record.name} <span style={{ color: '#0000FF' }}>En ciudad cercana: {record.city}</span></div>
                                        :
                                        <strike style={{ color: '#aaaaaa' }}>{record.name} <span>En ciudad cercana: {record.city}</span></strike>
                                }
                            </Popover>
                        </span>);
                }
            }
            }/>
            <Column title="Estado" dataIndex="active" key="active" align="center" width="20%"
                render={active => (
                    <span>
                        {
                            active ?
                                <Tag color='blue' key={active}>
                                    ACTIVADO
                                </Tag>
                                :
                                <Tag color='red' key={active}>
                                    DESACTIVADO
                                </Tag>
                        }
                    </span>
                )}
            />
        </Table>
    );
};

RestaurantsPriorityTable.propTypes = {
    data: PropTypes.array,
};

export default RestaurantsPriorityTable;